<template>
  <div class="page_settlementTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="数据类型:">
              <el-select v-model="listQuery.dataType" size="small" filterable clearable placeholder="" style="width: 140px;">
                <el-option v-for="(item, index) in dataTypeList" :key="index" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目:">
              <el-select v-model="listQuery.projectId" size="small" filterable clearable placeholder="" style="width: 140px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select v-model="listQuery.busiStat" size="small" filterable clearable placeholder="" style="width: 140px;">
                <el-option label="待上链" :value="1"></el-option>
                <el-option label="成功" :value="2"></el-option>
                <el-option label="失败" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>上链任务管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="总览看板" name="0"></el-tab-pane>
          <el-tab-pane label="上链任务管理" name="1"></el-tab-pane>
          <el-tab-pane label="存证查询与验证" name="2"></el-tab-pane>
          <!-- <el-tab-pane label="证据出具" name="3"></el-tab-pane> -->
          <el-tab-pane label="系统管理" name="4"></el-tab-pane>
        </el-tabs>
        <!-- tab 0: 总览看板 -->
        <div v-if="activeName === '0'" class="overview">
          <div class="overview-kpi-row">
            <!-- 累计存证量 -->
            <div class="overview-kpi">
              <div class="kpi-head">
                <div class="kpi-title"><span class="kpi-title-bar"></span>累计存证量</div>
                <i class="el-icon-data-line kpi-icon"></i>
              </div>
              <div class="kpi-body">
                <div class="kpi-num">{{ overviewStats.totalCount.toLocaleString() }}<span class="kpi-unit">条</span></div>
                <div class="kpi-diff">较昨日 <span class="kpi-diff-up" v-if="overviewStats.totalDiffUp">↑</span><span class="kpi-diff-down" v-else>↓</span> {{ overviewStats.totalDiff }}%</div>
              </div>
              <div class="kpi-spark" ref="sparkTotal"></div>
              <div class="kpi-icon-big">
                <svg viewBox="0 0 48 48" width="44" height="44">
                  <defs>
                    <linearGradient id="gradUp" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stop-color="#409EFF" stop-opacity="0.3" />
                      <stop offset="100%" stop-color="#409EFF" stop-opacity="1" />
                    </linearGradient>
                  </defs>
                  <circle cx="24" cy="24" r="22" fill="url(#gradUp)" />
                  <path d="M24 14 L32 26 L27 26 L27 34 L21 34 L21 26 L16 26 Z" fill="#fff" />
                </svg>
              </div>
            </div>
            <!-- 今日上链 -->
            <div class="overview-kpi">
              <div class="kpi-head">
                <div class="kpi-title"><span class="kpi-title-bar"></span>今日上链</div>
                <i class="el-icon-document-checked kpi-icon"></i>
              </div>
              <div class="kpi-body">
                <div class="kpi-num">{{ overviewStats.todayCount.toLocaleString() }}<span class="kpi-unit">条</span></div>
                <div class="kpi-diff">较昨日 <span class="kpi-diff-up" v-if="overviewStats.todayDiffUp">↑</span><span class="kpi-diff-down" v-else>↓</span> {{ overviewStats.todayDiff }}%</div>
              </div>
              <div class="kpi-spark" ref="sparkToday"></div>
              <div class="kpi-icon-big kpi-icon-big--blue">
                <svg viewBox="0 0 48 48" width="44" height="44">
                  <circle cx="24" cy="24" r="22" fill="rgba(64,158,255,0.25)" />
                  <path d="M18 24 A6 6 0 1 0 18 24.01 Z" fill="#409EFF" />
                  <path d="M22 18 L26 18 L26 24 L22 24 Z" fill="#409EFF" />
                  <circle cx="32" cy="22" r="3" fill="#409EFF" /></svg>
              </div>
            </div>
          </div>
          <!-- 最近上链记录 -->
          <div class="overview-section">
            <div class="overview-sec-head flex sb aic">
              <span class="overview-sec-title">最近上链记录</span>
              <el-button type="primary" size="small" plain @click="goToAllChain">查看全部</el-button>
            </div>
            <el-table :data="overviewChainList" border class="doc_table" size="small" style="width:100%">
              <el-table-column prop="updataTime" label="操作时间" min-width="160" align="center">
                <template slot-scope="{row}">
                  {{ row.updataTime ? row.updataTime.replace('T', ' ') : '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="projectName" label="项目名称" min-width="130" align="center"></el-table-column>
              <el-table-column prop="dataType" label="数据类型" min-width="120" align="center"></el-table-column>
              <el-table-column label="上链方式" min-width="110" align="center">
                <template slot-scope={row}>
                  <el-tag v-if="row.busiStat == '1'" type="info" size="small">待上链</el-tag>
                  <el-tag v-else-if="row.busiStat == '2'" type="success" size="small">成功</el-tag>
                  <el-tag v-else-if="row.busiStat == '3'" type="danger" size="small">失败</el-tag>
                  <el-tag v-else size="small">{{ row.busiStat }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="160" align="center">
                <template slot-scope="{row}">
                  <div class="chain-ops flex aic" style="justify-content:center;">
                    <el-button type="text" size="small" @click="handleView(row)">查看</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- tab 1: 上链任务管理 -->
        <template v-if="activeName === '1'">
          <div class="ftabBtn flex">
            <el-button type="primary" size="small" @click="handleManualTrigger" v-preventReClick>手动触发</el-button>
            <el-button size="small" type="warning" @click="handleBatchRetry" v-preventReClick>批量重试</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="refreshList">刷新列表</el-button>
          </div>
          <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 180" v-loading="loading" style="width:100%">
            <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
            <el-table-column prop="index" label="序号" width="70" align="center">
              <template slot-scope={$index}>{{ (listQuery.pageModel.page - 1) * listQuery.pageModel.rows + $index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="projectName" label="项目" min-width="100" align="center"></el-table-column>
            <!-- <el-table-column prop="projectId" label="项目ID" min-width="130" align="center"></el-table-column> -->
            <el-table-column prop="dataType" label="数据类型" min-width="110" align="center"></el-table-column>
            <el-table-column prop="cycle" label="周期" min-width="100" align="center"></el-table-column>
            <el-table-column prop="recordCount" label="记录数" min-width="100" align="center">
              <template slot-scope={row}>{{ row.recordCount ? Number(row.recordCount).toLocaleString() : '0' }}</template>
            </el-table-column>
            <el-table-column prop="chainMethod" label="上链方式" min-width="110" align="center"></el-table-column>
            <el-table-column prop="busiStat" label="状态" min-width="100" align="center">
              <template slot-scope={row}>
                <el-tag v-if="row.busiStat == '1'" type="info" size="small">待上链</el-tag>
                <el-tag v-else-if="row.busiStat == '2'" type="success" size="small">成功</el-tag>
                <el-tag v-else-if="row.busiStat == '3'" type="danger" size="small">失败</el-tag>
                <el-tag v-else size="small">{{ row.busiStat }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" align="center" width="200">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="handleView(row)">查看</el-button>
                  <el-button type="text" size="small" v-if="row.busiStat == '1'" @click="handleChain(row)">上链</el-button>
                  <el-button type="text" size="small" v-if="row.busiStat == '3'" @click="handleRetry(row)">重试</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
          </div>
        </template>
      </div>
    </div>

    <!-- 手动上链弹窗 -->
    <el-dialog title="手动上链" :visible.sync="addVisible" width="500px" class="res_dialog enter_dialog" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="88px" size="small">
        <el-form-item label="数据类型:" prop="dataType">
          <el-select v-model="addForm.dataType" size="small" filterable clearable placeholder="" style="width: 300px;">
            <el-option v-for="(item, index) in dataTypeList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="addForm.projectId" size="small" filterable clearable placeholder="" style="width: 300px;">
            <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期" prop="cycle">
          <el-date-picker v-model="addForm.cycle" style="width:300px" type="month" value-format="yyyy-MM"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="详情" :visible.sync="detailVisible" width="600px" class="res_dialog enter_dialog">
      <el-descriptions v-if="currentRow" :column="2" border size="small">
        <el-descriptions-item label="项目">{{ currentRow.projectName }}</el-descriptions-item>
        <el-descriptions-item label="项目ID">{{ currentRow.projectId }}</el-descriptions-item>
        <el-descriptions-item label="数据类型">{{ currentRow.dataType }}</el-descriptions-item>
        <el-descriptions-item label="周期">{{ currentRow.period }}</el-descriptions-item>
        <el-descriptions-item label="记录数">{{ currentRow.recordCount }}</el-descriptions-item>
        <el-descriptions-item label="上链方式">{{ currentRow.chainMethod }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag v-if="currentRow.busiStat == 1" type="info" size="small">待上链</el-tag>
          <el-tag v-else-if="currentRow.busiStat == 3" type="danger" size="small">失败</el-tag>
          <el-tag v-else-if="currentRow.busiStat === 2" type="success" size="small">成功</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="上链时间" v-if="currentRow.chainTime">{{ currentRow.chainTime }}</el-descriptions-item>
        <el-descriptions-item label="错误信息" :span="2" v-if="currentRow.errorMsg">
          <span style="color:#f56c6c;">{{ currentRow.errorMsg }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import * as echarts from 'echarts';
  import checkPermission from '@/utils/permission'
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: []
          },
          cycle: '',
          busiStat: '',
          dataType: '',
          projectId: null
        },
        dataTypeList: [
          "录用通知",
          "排班记录",
          "接受排班",
          "任务派发记录",
          "接受任务",
          "考勤签到签退（含定位）",
          "考勤确认",
          "薪资确认",
          "验收单据",
          "结算资料",
          "付款凭证"
        ],
        addForm: {
          cycle: '',
          dataType: '',
          projectId: null
        },
        addVisible: false,
        isBtnLoading: false,
        addRules: {
          dataType: [{
            required: true,
            message: '数据类型',
            trigger: 'change'
          }],
          projectId: [{
            required: true,
            message: '项目',
            trigger: 'change'
          }],
          cycle: [{
            required: true,
            message: '周期',
            trigger: 'change'
          }]
        },
        projectList: [], //项目列表
        activeName: '0',
        loading: false,
        tableData: [],
        totalCount: 0,
        selectedRows: [],
        detailVisible: false,
        currentRow: null,
        dataTypeOptions: [{
            value: 'attendance',
            label: '考勤记录'
          },
          {
            value: 'payroll',
            label: '薪酬数据'
          },
          {
            value: 'contract',
            label: '合同信息'
          },
          {
            value: 'leave',
            label: '请假记录'
          }
        ],
        projectOptions: [{
            id: '1',
            name: '项目1'
          },
          {
            id: 'HRP-202605',
            name: 'HRP-202605'
          },
          {
            id: '3',
            name: '项目3'
          }
        ],
        statusOptions: [{
            value: 'pending',
            label: '待上链'
          },
          {
            value: 'failed',
            label: '失败'
          },
          {
            value: 'success',
            label: '成功'
          }
        ],
        periodOptions: [{
          value: '2026-05',
          label: '2026-05'
        }, {
          value: '2026-04',
          label: '2026-04'
        }, {
          value: '2026-03',
          label: '2026-03'
        }],
        // 总览看板数据
        overviewStats: {
          totalCount: 0,
          totalTrend: [1200, 1500, 1300, 1800, 2100, 1900, 2300, 2500, 2200, 2800, 3100, 3000],
          totalDiff: 1.2,
          totalDiffUp: true,
          todayCount: 0,
          todayTrend: [800, 900, 750, 1100, 1300, 1200, 1500, 1400, 1600, 1800, 1700, 2000],
          todayDiff: 0.8,
          todayDiffUp: true
        },
        overviewChainList: [],
        sparkTotalChart: null,
        sparkTodayChart: null
      }
    },
    created() {
      // this.getList();
      this.getProList();
      console.log(this.$route.query);
      if(this.$route.query.activeName!=undefined && this.$route.query.activeName){
        this.activeName = this.$route.query.activeName;
        this.changeTab();
      }else{
        this.getOverviewData()
      }
    },
    beforeDestroy() {
      if (this.sparkTotalChart) this.sparkTotalChart.dispose();
      if (this.sparkTodayChart) this.sparkTodayChart.dispose();
      window.removeEventListener('resize', this._onResize);
    },
    methods: {
      checkPermission,
      changeTab() {
        // 切换离开 tab 0 时释放图表实例
        if (this.activeName !== '0') {
          if (this.sparkTotalChart) {
            this.sparkTotalChart.dispose();
            this.sparkTotalChart = null;
          }
          if (this.sparkTodayChart) {
            this.sparkTodayChart.dispose();
            this.sparkTodayChart = null;
          }
          window.removeEventListener('resize', this._onResize);
        }
        if (this.activeName === '0') {
          this.$nextTick(() => {
            this.getOverviewData();
            this.drawSparklines();
            this._onResize = () => {
              this.sparkTotalChart && this.sparkTotalChart.resize();
              this.sparkTodayChart && this.sparkTodayChart.resize();
            };
            window.addEventListener('resize', this._onResize);
          });
        } else if (this.activeName === '1') {
          this.getList();
        } else if (this.activeName === '2') {
          this.$router.push({
            path: '/evidence'
          })
        }
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetBlockChainPageList').then(res => {
          if (res.status === 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.error(res.msg || '获取数据失败');
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching on-chain tasks:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      resetHandle() {
        this.listQuery.dataType = '';
        this.listQuery.projectId = '';
        this.listQuery.status = '';
        this.listQuery.period = '';
        this.searchHandle();
      },
      refreshList() {
        this.$message.success('列表已刷新');
        this.getList();
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      handleSelectionChange(rows) {
        this.selectedRows = rows;
      },
      handleManualTrigger() {
        this.addForm = {
          cycle: '',
          dataType: '',
          projectId: null
        };
        this.addVisible = true;
      },
      confirmAdd() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.ArdCurStat(this.addForm, 'AddBlockChain').then(res => {
              if (res.status === 'ok') {
                this.$message.success('上链任务已添加');
                this.addVisible = false;
                this.getList();
              } else {
                this.$message.error(res.msg || '添加失败');
              }
              this.isBtnLoading = false;
            }).catch(() => {
              this.isBtnLoading = false;
            });
          }
        });
      },
      //获取项目
      getProList() {
        let data = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1,
        };
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      handleBatchRetry() {
        if (this.selectedRows.length === 0) {
          this.$message.warning('请先选择要重试的记录');
          return;
        }
        const failedRows = this.selectedRows.filter(r => r.status === 'failed');
        if (failedRows.length === 0) {
          this.$message.warning('所选记录中没有失败状态的数据');
          return;
        }
        this.$confirm(`确认批量重试选中的 ${failedRows.length} 条失败记录？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const ids = failedRows.map(r => r.id);
          xz.ArdCurStat({
            ids: ids
          }, 'BatchRetryOnChain').then(res => {
            if (res.status === 'ok') {
              this.$message.success('批量重试已触发');
              this.getList();
            } else {
              this.$message.error(res.msg || '重试失败');
            }
          });
        }).catch(() => {});
      },
      handleView(row) {
        this.currentRow = row;
        this.detailVisible = true;
      },
      handleChain(row) {
        this.$confirm(`确认上链项目「${row.projectName}」的 ${row.dataType} 数据？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let str = `?Ids=${row.id}`
          xz.ArdCurStatGetFun('NotaryLocalData', str).then(res => {
            if (res.status === 'ok') {
              this.$message.success('操作成功！');
              this.getList();
            } else {
              this.$message.error(res.msg || '上链失败');
            }
          });
        }).catch(() => {});
      },
      handleRetry(row) {
        this.$confirm(`确认重试项目「${row.projectName}」的上链？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          xz.ArdCurStat({
            id: row.id
          }, 'RetryOnChain').then(res => {
            if (res.status === 'ok') {
              this.$message.success('重试已触发');
              this.getList();
            } else {
              this.$message.error(res.msg || '重试失败');
            }
          });
        }).catch(() => {});
      },
      // 获取看板数据：KPI 统计暂用模拟数据；最近上链记录复用 GetBlockChainPageList 接口（busiStat=2）
      getOverviewData() {
        // KPI 统计 - 暂无接口，使用模拟数据
        this.overviewStats.totalCount = 285346;
        this.overviewStats.totalDiff = 1.2;
        this.overviewStats.totalDiffUp = true;
        this.overviewStats.todayCount = 1284;
        this.overviewStats.todayDiff = 0.8;
        this.overviewStats.todayDiffUp = true;
        // 最近上链记录：复用列表接口，状态筛选为「成功」
        const recentQuery = {
          pageModel: {
            rows: 5,
            page: 1,
            orderInput: []
          },
          busiStat: ''
        };
        xz.ArdCurStat(recentQuery, 'GetBlockChainPageList').then(res => {
          if (res.status === 'ok') {
            this.overviewChainList = res.data.data || [];
          } else {
            this.overviewChainList = [];
          }
        }).catch(() => {
          this.overviewChainList = [];
        });
      },
      // 绘制迷你趋势图（sparkline）
      drawSparklines() {
        // 累计存证量趋势
        const el1 = this.$refs.sparkTotal;
        if (el1) {
          if (this.sparkTotalChart) this.sparkTotalChart.dispose();
          this.sparkTotalChart = echarts.init(el1);
          this.sparkTotalChart.setOption({
            grid: {
              left: 0,
              right: 0,
              top: 2,
              bottom: 2
            },
            xAxis: {
              show: false,
              type: 'category',
              data: this.overviewStats.totalTrend.map((_, i) => i)
            },
            yAxis: {
              show: false,
              type: 'value'
            },
            tooltip: {
              show: false
            },
            series: [{
              type: 'line',
              data: this.overviewStats.totalTrend,
              smooth: true,
              symbol: 'none',
              lineStyle: {
                color: '#409EFF',
                width: 2
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(64,158,255,0.25)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(64,158,255,0.02)'
                  }
                ])
              }
            }]
          });
        }
        // 今日上链趋势
        const el2 = this.$refs.sparkToday;
        if (el2) {
          if (this.sparkTodayChart) this.sparkTodayChart.dispose();
          this.sparkTodayChart = echarts.init(el2);
          this.sparkTodayChart.setOption({
            grid: {
              left: 0,
              right: 0,
              top: 2,
              bottom: 2
            },
            xAxis: {
              show: false,
              type: 'category',
              data: this.overviewStats.todayTrend.map((_, i) => i)
            },
            yAxis: {
              show: false,
              type: 'value'
            },
            tooltip: {
              show: false
            },
            series: [{
              type: 'line',
              data: this.overviewStats.todayTrend,
              smooth: true,
              symbol: 'none',
              lineStyle: {
                color: '#409EFF',
                width: 2
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(64,158,255,0.25)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(64,158,255,0.02)'
                  }
                ])
              }
            }]
          });
        }
      },
      // 查看全部 → 切换到上链任务 tab
      goToAllChain() {
        this.activeName = '1';
        this.getList();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 16px 16px 16px;
    margin-bottom: 16px;
  }

  .filter_bar {
    margin-bottom: 8px;
  }

  .filter_bar .el-form-item {
    margin-bottom: 8px;
    margin-right: 8px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  /* ====== 总览看板 ====== */
  .overview {
    padding-top: 12px;
  }

  .overview-kpi-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 20px;
  }

  .overview-kpi {
    position: relative;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 16px 18px 6px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .kpi-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .kpi-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .kpi-title-bar {
    display: inline-block;
    width: 3px;
    height: 14px;
    background: #409EFF;
    border-radius: 2px;
  }

  .kpi-icon {
    font-size: 16px;
    color: #c0c4cc;
    cursor: pointer;
  }

  .kpi-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 6px;
  }

  .kpi-num {
    font-family: 'SF Mono', 'Cascadia Code', 'Roboto Mono', 'Consolas', monospace;
    font-size: 28px;
    font-weight: 700;
    color: #303133;
    line-height: 1.2;
  }

  .kpi-unit {
    font-size: 13px;
    font-weight: 400;
    color: #909399;
    margin-left: 4px;
  }

  .kpi-diff {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
  }

  .kpi-diff-up {
    color: #52c41a;
    font-weight: 600;
  }

  .kpi-diff-down {
    color: #f56c6c;
    font-weight: 600;
  }

  .kpi-icon-big {
    position: absolute;
    right: 18px;
    bottom: 8px;
    opacity: 0.55;
    pointer-events: none;
    z-index: 0;
  }

  .kpi-spark {
    height: 50px;
    width: 70%;
    position: relative;
    z-index: 1;
  }

  /* 最近上链记录 */
  .overview-section {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 16px 16px 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .overview-sec-head {
    margin-bottom: 12px;
  }

  .overview-sec-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .overview-sec-title::before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 14px;
    background: #409EFF;
    border-radius: 2px;
  }

  .chain-ops {
    gap: 10px;
  }

  .chain-hash {
    display: inline-block;
    min-width: 64px;
    padding: 2px 8px;
    border-radius: 4px;
    font-family: 'SF Mono', 'Cascadia Code', 'Consolas', monospace;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background: #67c23a;
    line-height: 1.6;
    letter-spacing: 0.5px;
  }

  .chain-hash--red {
    background: #f56c6c;
  }
</style>

<style>
  .page_settlementTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementTask .el-input-group__append,
  .page_settlementTask .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .el-descriptions__label {
    width: 100px;
  }
</style>